import React, { useState, useCallback, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Alert } from '@mui/material';
import HaiInputPanel from '../components/HaiInputPanel';
import Controls from '../components/Controls';
import PredictionResult from '../components/PredictionResult';
import { fetchPrediction } from '../api';

const DahaiPredictionPage = ({ setPageTitle }) => {
  // --- 状態管理 ---
  const [tehai, setTehai] = useState([]);
  const [furos, setFuros] = useState([[], [], [], []]); // 4つの副露エリア
  const [prediction, setPrediction] = useState(null);
  const [tehaiAtPrediction, setTehaiAtPrediction] = useState(null); // 推論実行時の手牌を保持
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [panelKey, setPanelKey] = useState(Date.now()); // HaiInputPanelをリセットするためのキー

  const { modelVersion } = useParams();
  const navigate = useNavigate();

  // AppBarのタイトルを設定
  useEffect(() => {
    const modelLabels = {
      v5: 'v5 (七対子対応)',
      v4: 'v4 (旧モデル)',
    };
    const currentModelLabel = modelLabels[modelVersion];

    if (currentModelLabel) {
      setPageTitle(`打牌推論 (${currentModelLabel})`);
    } else {
      console.warn(`不正なモデルバージョン: ${modelVersion}。v5にリダイレクトします。`);
      navigate('/dahai-prediction/v5', { replace: true });
    }
  }, [setPageTitle, modelVersion, navigate]);

  /**
   * HaiInputPanelから状態の変更を受け取るコールバック
   */
  const handleStateChange = useCallback(({ tehai, furos }) => {
    setTehai(tehai);
    setFuros(furos);
  }, []);

  /**
   * すべての牌と推論結果をクリアする関数
   */
  const handleClear = () => {
    setTehai([]);
    setFuros([[], [], [], []]);
    setPrediction(null);
    setTehaiAtPrediction(null);
    setError('');
    setPanelKey(Date.now()); // keyを更新してHaiInputPanelを再マウントさせる
  };

  /**
   * バックエンドAPIを呼び出して推論を実行する関数
   */
  const handlePredict = useCallback(async () => {
    setIsLoading(true);
    setError('');
    setPrediction(null);
    try {
      // 推論実行時の手牌の状態を保存
      setTehaiAtPrediction(tehai);
      const result = await fetchPrediction(tehai, furos, modelVersion);
      setPrediction(result);
    } catch (err) {
      // axiosのエラーレスポンス、フロントエンドのバリデーションエラー、その他のエラーを適切に処理
      setError(err.response?.data?.detail || err.message || '推論中にエラーが発生しました。');
    } finally {
      setIsLoading(false);
    }
  }, [tehai, furos, modelVersion]); // 依存配列にmodelVersionを追加

  return (
    <>
      <HaiInputPanel key={panelKey} onStateChange={handleStateChange}>
        <Controls onClear={handleClear} onPredict={handlePredict} isLoading={isLoading} />
      </HaiInputPanel>

      <Box sx={{ mt: 4 }}>
        {error && <Alert severity="error">{error}</Alert>}
        {prediction && tehaiAtPrediction && <PredictionResult prediction={prediction} tehai={tehaiAtPrediction} />}
      </Box>
    </>
  );
};

export default DahaiPredictionPage;
